import Router, { Route } from 'preact-router';
import { BASE_PATH } from '../shared/types';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { Admin } from './pages/Admin';
import { Feedback } from './pages/Feedback';
import { EventEditor } from './pages/EventEditor';
import { Register } from './pages/Register';
import { NotFound } from './pages/NotFound';
import { Help } from './pages/Help';
import { SiteFooter } from './components/SiteFooter';

/** A registration link: /r/<identifier>, with any slug after it, which is only for reading. */
function Registration({ linkId }: { linkId?: string }) {
  return <Register key={linkId} linkId={linkId ?? ''} />;
}

export function App() {
  return (
    <>
    <Router>
      <Route path={`${BASE_PATH}/`} component={Home} />
      <Route path={`${BASE_PATH}/login`} component={Login} />
      <Route path={`${BASE_PATH}/dashboard`} component={Dashboard} />
      <Route path={`${BASE_PATH}/admin`} component={Admin} />
      <Route path={`${BASE_PATH}/feedback`} component={Feedback} />
      <Route path={`${BASE_PATH}/help`} component={Help} />
      <Route path={`${BASE_PATH}/events/:id`} component={EventEditor} />
      <Route path={`${BASE_PATH}/r/:linkId/:slug*`} component={Registration} />
      <Route default component={NotFound} />
    </Router>
    <SiteFooter />
    </>
  );
}
